import { render } from "./ShrirangSapate.vue?vue&type=template&id=b637f83a&scoped=true"
import script from "./ShrirangSapate.vue?vue&type=script&lang=js"
export * from "./ShrirangSapate.vue?vue&type=script&lang=js"

import "./ShrirangSapate.vue?vue&type=style&index=0&id=b637f83a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b637f83a"]])

export default __exports__